import React from 'react';
import { Link } from 'react-router-dom';
import { Menu } from 'antd';
import './navItemStyle.scss';

const { SubMenu } = Menu;

const NavItems = (siderHidden, routes) => {
	if (!routes || routes.length === 0) return null;

	return (
		<Menu className='menu-item-style' mode='inline' style={{ backgroundColor: 'inherit' }} theme='light'>
			{routes.map((route, index) => {
				// If route has sub-items
				if (route.items && route.items.length > 0) {
					return (
						<SubMenu
							key={route.pk || index}
							title={
								<span className='menu-item-content'>
									{route.icon}
									<span className='menu-item-name'>{route.name}</span>
								</span>
							}
						>
							{route.items.map((subItem, subIndex) => (
								<Menu.Item className='paymate-sider-item' key={`${route.pk}-${subIndex}`}>
									<Link to={subItem.path}>
										<span>{subItem.name}</span>
									</Link>
								</Menu.Item>
							))}
						</SubMenu>
					);
				} else {
					// If route is a standalone item
					return !route.hidden && (
						<Menu.Item className='paymate-sider-item' key={index}>
							<Link to={route.path}>
								<span className='menu-item-content'>
									{route.icon}
									<span className='menu-item-name'>{route.name}</span>
								</span>
							</Link>
						</Menu.Item>
					);
				}
			})}
		</Menu>
	);
};

export default NavItems;
